import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

import authenticationService from 'services/AuthenticationService';
import { useAppMode } from 'contexts/AppModeContext';
import commonStrings from 'modules/common/strings';
import { contextToPageNameMap } from 'constants/context';

import useCustomNavigation from 'hooks/useCustomNavigation';
import { selectedHealthPlanCountrySelector } from 'modules/healthPlans/healthPlansSlice';
import {
  Wrapper,
  PageName,
  UserNameWrapper,
  UserName,
  LogoutPopup,
  Logout,
  BackButton,
  BreadCrumbWrapper,
  BreadCrumb,
  CountryLabelWrapper,
} from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);

  const userNameWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (userNameWrapperRef.current && userNameWrapperRef.current.contains(event.target) === false)
        setIsLogoutPopupOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [userNameWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const { routeHistory, goBack, handleNavigation } = useCustomNavigation();
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleUsernameClick = () => {
    setIsLogoutPopupOpen(prevState => !prevState);
  };

  const { isEmbedded } = useAppMode();

  const handleLogoutClick = async () => {
    setIsLogoutPopupOpen(false);

    if (isEmbedded) {
      return;
    }

    try {
      await authenticationService.logout();
      document.location.href = '/login';
    } catch (error) {
      // Still redirect to login even if logout fails
      document.location.href = '/login';
    }
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  const renderBreadCrumbs = () => (
    <BreadCrumbWrapper>
      {routeHistory.map((route, index) => (
        <>
          <BreadCrumb onClick={() => handleNavigation(route.path)} isFirst={index === 0}>
            {route.label}
          </BreadCrumb>
          {index < routeHistory.length - 1 && ' / '}
        </>
      ))}
    </BreadCrumbWrapper>
  );
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const pageName = contextToPageNameMap[context];
  const username = Cookies.get('nameAuthCookie') || Cookies.get('emailAuthCookie') || '';
  const selectedHealthPlanCountry = useSelector(selectedHealthPlanCountrySelector);

  return (
    <>
      <Wrapper>
        {routeHistory.length > 1 && <BackButton onClick={() => goBack()} />}
        <PageName>{pageName}</PageName>
        {selectedHealthPlanCountry && (
          <CountryLabelWrapper>
            <img
              width="24px"
              height="24px"
              src={selectedHealthPlanCountry?.IconUrl}
              alt={selectedHealthPlanCountry?.name}
            />
            <span>{selectedHealthPlanCountry?.name}</span>
          </CountryLabelWrapper>
        )}
        {!isEmbedded && (
          <UserNameWrapper ref={userNameWrapperRef}>
            <UserName
              onClick={() => handleUsernameClick()}
            >{`${commonStrings.header.userNameText} ${username}`}</UserName>
            {isLogoutPopupOpen && (
              <LogoutPopup>
                <Logout onClick={() => handleLogoutClick()}>
                  {commonStrings.header.logoutText}
                </Logout>
              </LogoutPopup>
            )}
          </UserNameWrapper>
        )}
      </Wrapper>
      {routeHistory.length > 1 && renderBreadCrumbs()}
    </>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
